import { Pipe, PipeTransform } from '@angular/core';

/**
 * To use pipe:
 *
 * @example
 *
 * // custom alt string
 * {{patient.surname | beeAlt: 'ddkfk'}}
 * // default alt string
 * {{patient.surname | beeAlt}}
 */
@Pipe({
  name: 'beeAlt'
})
export class BeeAltPipe implements PipeTransform {

  /**
   * Pipe transform.
   * @param value
   * @param altString
   */
  transform(value: any, altString: string = '-'): any {
    if (value) {
      return value;
    } else {
      return altString;
    }
  }
}
